import { Alert, Box, LinearProgress, Typography } from "@mui/material";
import { exchangeQuoteMessageKey } from "./options";
import { formatMoney } from "../formatters";
import type { ClaimTranslator, ExchangeQuote } from "../types";

type ExchangeQuoteSummaryProps = {
  quote: ExchangeQuote | null;
  error: string | null;
  status: string;
  t: ClaimTranslator;
};

export const ExchangeQuoteSummary = ({
  quote,
  error,
  status,
  t,
}: ExchangeQuoteSummaryProps) => {
  if (status === "idle") return null;

  return (
    <Box mb="24px">
      <Typography fontWeight="bold" fontSize="16px" mb="8px">
        {t("review.exchangeQuote.title")}
      </Typography>
      {status === "loading" && <LinearProgress />}
      {status === "error" && <Alert severity="error">{error}</Alert>}
      {quote && !quote.allowed && (
        <Alert severity="warning">{quote.reason}</Alert>
      )}
      {quote?.allowed && (
        <Alert severity={Number(quote.net_difference) > 0 ? "info" : "success"}>
          {t(exchangeQuoteMessageKey(quote) ?? "review.exchangeQuote.even", {
            amount:
              formatMoney(
                Math.abs(Number(quote.net_difference)),
                quote.currency || undefined,
              ) ?? "",
          })}
        </Alert>
      )}
    </Box>
  );
};
